import { render } from "./skuinfo.vue?vue&type=template&id=4016cd43&scoped=true"
import script from "./skuinfo.vue?vue&type=script&lang=js"
export * from "./skuinfo.vue?vue&type=script&lang=js"

import "./skuinfo.vue?vue&type=style&index=0&id=4016cd43&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4016cd43"]])

export default __exports__